export default function cleanString(str) {
    return str.replaceAll(" ", "")
        .replaceAll("-", "")
        .replaceAll(",", "")
        .replaceAll(".", "")
        .replaceAll(/[0-9]/g, "")
        .replaceAll("?", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("+", "")
        .replaceAll("-", "")
        .replaceAll("/", "")
        .replaceAll("*", "")
        .replaceAll(":", "")
        .replaceAll("ç", "c")
        .replaceAll("ã", "a")
        .replaceAll("á", "a")
        .replaceAll("à", "a")
        .replaceAll("â", "a")
        .replaceAll("é", "e")
        .replaceAll("ê", "e")
        .replaceAll("í", "i")
        .replaceAll("ó", "o")
        .replaceAll("õ", "o")
        .replaceAll("ú", "u")
        .replaceAll("ü", "u")
        .trim()
}

